import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton, Alert } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { logoHorizontalTransparent } from '../LandingPage/images';
import useLogin from './login';
import InitialOptions from './InitialOptions';
import EmailLogin from './EmailLogin';
import SignupForm from './SignupForm';

export default function LoginModal({ open, onClose }) {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const {
        mode,
        setMode,
        formData,
        setFormData,
        handleGoogleLogin,
        handleEmailLogin,
        handleSignup
    } = useLogin({ 
        onError: (msg) => {
            setSuccessMessage(''); // Clear success message when there's an error
            setError(msg);
        },
        onSuccess: (msg) => {
            setError(''); // Clear error message when there's success
            setSuccessMessage(msg);
        }
    });

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Clear error when switching modes
    const handleModeChange = (newMode) => {
        setError('');
        setSuccessMessage('');
        setMode(newMode);
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2, p: 2 }
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#2B0063'
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                gap: 3,
                py: 4
            }}>
                <img
                    src={logoHorizontalTransparent}
                    alt="LastCall Logo"
                    style={{ 
                        width: '200px',
                        height: 'auto',
                        objectFit: 'contain',
                        marginBottom: '1rem'
                    }}
                />
                
                {mode === 'initial' && (
                    <InitialOptions 
                        onGoogleLogin={handleGoogleLogin}
                        onEmailLogin={() => handleModeChange('email-login')}
                    />
                )}
                
                {mode === 'email-login' && (
                    <EmailLogin 
                        formData={formData}
                        onInputChange={handleInputChange}
                        onSubmit={handleEmailLogin}
                        onBack={() => handleModeChange('initial')}
                        onSignup={() => handleModeChange('signup')}
                        showPassword={showPassword}
                        onTogglePassword={() => setShowPassword(!showPassword)}
                    />
                )}
                {mode === 'signup' && (
                    <SignupForm 
                        formData={formData}
                        onInputChange={handleInputChange}
                        onSubmit={handleSignup}
                        onBack={() => handleModeChange('initial')}
                        showPassword={showPassword}
                        showConfirmPassword={showConfirmPassword}
                        onTogglePassword={() => setShowPassword(!showPassword)}
                        onToggleConfirmPassword={() => setShowConfirmPassword(!showConfirmPassword)}
                    />
                )}
                {/* Show error message if there is one */}
                {error && (
                    <Alert severity="error" sx={{ width: '100%', maxWidth: '300px' }}>
                        {error}
                    </Alert>
                )}
                {/* Show success message if there is one */}
                {successMessage && (
                    <Alert severity="success" sx={{ width: '100%', maxWidth: '300px' }}>
                        {successMessage}
                    </Alert>
                )}
            </DialogContent>
        </Dialog>
    );
} 